export function PageNotFound(props) {
  return <div className="m-5 p-5 border border-warning fs-1 text text-center fw-bold font-monospace">PAGE NOT FOUND</div>
}
